<template>
  <router-link style="text-decoration: none" :to="userSystem.relativeUrl">
    <div class="systemSquare">
      <!-- <div class="systemSquare" @click="openSystem(userSystem.projectTemplateId)"></div> -->
      <!-- Image Variant A-->
      <svg
        v-if="variant == 'A'"
        width="386"
        height="527"
        viewBox="0 0 386 527"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <mask
          :id="'mask0_' + index"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="386"
          height="527"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M353 40C353 17.9086 335.091 0 313 0H40C17.9086 0 0 17.9086 0 40V487C0 509.091 17.9086 527 40 527H313C335.091 527 353 509.091 353 487V480.054C353 465.572 363.426 453.446 373.289 442.842C379.739 435.907 384.141 427.039 385.531 417.204C385.547 417.088 385.647 417 385.764 417C385.895 417 386 416.895 386 416.764V410.5V225.016C386 225.007 385.993 225 385.984 225C385.975 225 385.968 224.993 385.969 224.984C385.99 224.492 386 223.997 386 223.5C386 218.531 384.95 213.808 383.059 209.539C374.38 189.949 353 172.133 353 150.707V40Z"
            fill="#D9D9D9"
          />
        </mask>
        <g :mask="'url(#mask0_' + index + ')'">
          <rect
            x="0"
            y="0"
            width="386"
            height="527"
            :fill="'url(#pattern0_' + index + ')'"
          />
        </g>
        <defs>
          <pattern
            :id="'pattern0_' + index"
            patternUnits="userSpaceOnUse"
            width="386"
            height="527"
          >
            <image
              :id="'image0_' + index"
              width="386"
              height="527"
              preserveAspectRatio="xMidYMid slice"
              :xlink:href="userSystem.tileImage"
            />
          </pattern>
        </defs>
      </svg>
      <!-- Image Variant B-->
      <svg
        v-if="variant == 'B'"
        width="397"
        height="527"
        viewBox="0 0 397 527"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <mask
          :id="'mask0_' + index"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="397"
          height="527"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 40C0 17.9086 17.9086 0 40 0H58H265H309C331.091 0 349 17.9086 349 40V74C349 87.2548 359.745 98 373 98C386.255 98 397 108.745 397 122V487C397 509.091 379.091 527 357 527H349H132H98C75.9086 527 58 509.091 58 487V427C58 410.984 45.0163 398 29 398C12.9837 398 0 385.016 0 369V40Z"
            fill="#D9D9D9"
          />
        </mask>
        <g :mask="'url(#mask0_' + index + ')'">
          <rect
            x="-165"
            y="-33"
            width="568"
            height="568"
            :fill="'url(#pattern0_' + index + ')'"
          />
          <!-- <rect
            x="-165"
            y="-33"
            width="568"
            height="568"
            :fill="'url(#pattern1_' + index + ')'"
          /> -->
        </g>
        <defs>
          <pattern
            :id="'pattern0_' + index"
            patternUnits="userSpaceOnUse"
            width="397"
            height="527"
          >
            <image
              :id="'image0_' + index"
              width="397"
              height="527"
              preserveAspectRatio="xMidYMid slice"
              :xlink:href="userSystem.tileImage"
            />
          </pattern>
        </defs>
      </svg>
      <!-- Image Variant C-->
      <svg
        v-if="variant == 'C'"
        width="414"
        height="527"
        viewBox="0 0 414 527"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <mask
          :id="'mask0_' + index"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="414"
          height="527"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M33 40C33 17.9086 50.9086 0 73 0H346C368.091 0 386 17.9086 386 40V156.517C386 175.72 403.102 191.85 410.98 209.362C412.92 213.677 414 218.462 414 223.5C414 223.997 413.99 224.492 413.969 224.984C413.968 224.993 413.975 225 413.984 225C413.993 225 414 225.007 414 225.016V410.5V416.764C414 416.895 413.895 417 413.764 417C413.647 417 413.547 417.087 413.531 417.204C412.213 426.528 408.189 434.982 402.278 441.745C394.096 451.106 386 461.819 386 474.252V487C386 509.091 368.091 527 346 527H56.8488C43.6775 527 33 516.323 33 503.151C33 492.782 25.8422 484.037 17.7605 477.54C8.57656 470.157 2.19631 459.428 0.469431 447.204C0.452961 447.088 0.353289 447 0.235543 447C0.105456 447 0 446.895 0 446.764V440.5V304.002C0 304.001 0.000788922 304 0.00176211 304C0.00274508 304 0.00353799 303.999 0.00352408 303.998C0.00117732 303.832 0 303.666 0 303.5C0 298.531 1.05044 293.808 2.94136 289.539C11.6202 269.949 33 252.133 33 230.707V40Z"
            fill="#D9D9D9"
          />
        </mask>
        <g :mask="'url(#mask0_' + index + ')'">
          <rect
            x="-133"
            y="-3"
            width="629"
            height="532.854"
            :fill="'url(#pattern0_' + index + ')'"
          />
          <!-- <rect
            x="-3"
            y="-9"
            width="469"
            height="397"
            :fill="'url(#pattern1_' + index + ')'"
          />
          <rect
            x="-84"
            y="-8.5"
            width="629"
            height="532.854"
            :fill="'url(#pattern2_' + index + ')'"
          />
          <rect
            x="-84"
            y="-8.5"
            width="629"
            height="532.854"
            :fill="'url(#pattern3_' + index + ')'"
          /> -->
        </g>
        <defs>
          <pattern
            :id="'pattern0_' + index"
            patternUnits="userSpaceOnUse"
            width="414"
            height="527"
          >
            <image
              :id="'image0_' + index"
              width="414"
              height="527"
              preserveAspectRatio="xMidYMid slice"
              :xlink:href="userSystem.tileImage"
            />
          </pattern>
        </defs>
      </svg>

      <div class="align-center sigflo-bodyLarge imageSubtext">
        {{ userSystem.webDescription }}
      </div>
      <div class="titleChip text-center" :class="paddingClass">
        <v-btn
          x-large
          rounded
          size=""
          color="rgba(255,255,255,0.9)"
          class="sigflo-bodyLead py-8"
          >{{ userSystem.title }}</v-btn
        >
      </div>
    </div>
  </router-link>
</template>

<script>
  export default {
    data() {
      return {
        imageId: `image_${this.index}_${this.idSuffix}`
      };
    },
    props: {
      userSystem: Object,
      variant: String,
      index: Number,
      idSuffix: String
    },
    computed: {
      paddingClass() {
        switch (this.variant) {
          case 'A':
            return 'titleChipA';
          case 'B':
            return 'titleChipB';
          case 'C':
            return 'titleChipC';
        }
        return 'titleChipD';
      }
    }
  };
</script>

<style scoped>
  .systemSquare {
    position: relative;
    opacity: 0.85;
    cursor: pointer;
    width: 400px;
  }
  .systemSquare:hover {
    opacity: 1;
    transform: scale(1.05);
  }
  .userSystemImage {
    filter: brightness(70%) contrast(100%) grayscale(0%) sepia(0%);
  }
  .titleChip {
    position: absolute;
    width: 100%;
    top: 440px;
    left: 0px;
  }
  .titleChipA {
    padding-left: 0px;
  }
  .titleChipB {
    padding-left: 70px;
  }
  .titleChipC {
    padding-left: 20px;
  }
</style>
